<template>
    <bita-modal
            :id="modalId"
            :title="title"
            :modal-lg="true"
            :isLoading="isLoading"
            @close="onCloseModal">
        <div slot="body">
            <div v-if="!this.propsData.request
                    || !this.propsData.user
                    || !this.propsData.customer_id
                    || !this.propsData.carrier
                    || !this.propsData.driver
                    || !this.propsData.wallet_log">
                <div class="alert alert-primary">
                    اطلاعات این بار تکمیل نمی باشد.
                </div>
            </div>
            <bita-formgroup v-if="this.propsData.request" title="اطلاعات بار" class="row">
                <label-value label="کد پیگیری" :value="propsData.tracking_code"/>
                <label-value label="نوع ماشین" :value="propsData.request.vehicle_type.name" />
                <label-value label="نوع بار" :value="propsData.load_data.name" />
                <label-value label="تناژ" :value="propsData.request.tonnage" />
                <label-value label="مبدا" :value="propsData.request.origin.province.name +' / '+ propsData.request.origin.name" />
                <label-value label="مقصد" :value="propsData.request.destination.province.name +' / '+ propsData.request.destination.name" />
                <label-value label="زمان بارگیری" :value="this.$getJalaliDate(propsData.request.loading_at)" />
                <label-value label="زمان تحویل" :value="this.$getJalaliDate(propsData.request.delivery_at)" />
            </bita-formgroup>
            <bita-formgroup v-if="this.propsData.user"  title="اطلاعات صاحب بار" class="row">
                <label-value label="نام شرکت" :value="propsData.user.name"/>
                <label-value label="نام" :value="propsData.user.user.name" />
                <label-value label="نام خانوادگی" :value="propsData.user.user.family" />
                <label-value label="کد ملی" :value="propsData.user.user.national_code" />
                <label-value label="شماره تماس" :value="propsData.user.user.phone" />
                <label-value label="کد پستی" :value="propsData.user.user.postal_code" />
                <label-value label="استان" :value="propsData.user.user.city.province.name" />
                <label-value label="شهر" :value="propsData.user.user.city.name" />
            </bita-formgroup>
            <bita-formgroup v-if="this.propsData.customer"  title="اطلاعات مشتری" class="row">
                <label-value label="نام" :value="propsData.customer.name" />
                <label-value label="نام خانوادگی" :value="propsData.customer.family" />
                <label-value label="کد ملی" :value="propsData.customer.national_code" />
                <label-value label="شماره تماس" :value="propsData.customer.phone" />
                <label-value label="کد پستی" :value="propsData.customer.postal_code" />
                <label-value label="استان" :value="propsData.customer.city.province.name" />
                <label-value label="شهر" :value="propsData.customer.city.name" />
            </bita-formgroup>
            <bita-formgroup v-if="this.propsData.carrier" title="اطلاعات باربری" class="row">
                <label-value label="نام باربری" :value="propsData.carrier.name" />
                <label-value label="نام صاحب باربری" :value="propsData.carrier.boss_name" />
                <label-value label="نام" :value="propsData.carrier.user.name" />
                <label-value label="نام خانوادگی" :value="propsData.carrier.user.family" />
                <label-value label="کد ملی" :value="propsData.carrier.user.national_code" />
                <label-value label="شماره تماس" :value="propsData.carrier.user.phone" />
                <label-value label="کد پستی" :value="propsData.carrier.user.postal_code" />
                <label-value label="استان" :value="propsData.carrier.user.city.province.name" />
                <label-value label="شهر" :value="propsData.carrier.user.city.name" />
            </bita-formgroup>
            <bita-formgroup v-if="this.propsData.driver" title="اطلاعات راننده" class="row">
                <label-value label="نام" :value="propsData.driver.user.name" />
                <label-value label="نام خانوادگی" :value="propsData.driver.user.family" />
                <label-value label="کد ملی" :value="propsData.driver.user.national_code" />
                <label-value label="شماره تماس" :value="propsData.driver.user.phone" />
                <label-value label="کد پستی" :value="propsData.driver.user.postal_code" />
                <label-value label="استان" :value="propsData.driver.user.city.province.name" />
                <label-value label="شهر" :value="propsData.driver.user.city.name" />
            </bita-formgroup>
            <bita-formgroup v-if="this.propsData.wallet_log" title="اطلاعات مالی" class="row">
                <label-value label="مبلغ قابل پرداخت" :value="propsData.amount_payable" />
                <label-value label="مبلغ کسر شده از کیف پول" :value="propsData.wallet_log.amount" />
                <label-value label="تاریخ و روز" :value="this.$getJalaliDateTime(propsData.wallet_log.created_at)" />
                <label-value label="مشخصات" :value="propsData.wallet_log.user.name + ' / ' + propsData.wallet_log.user.family" />
                <label-value label="کدملی" :value="propsData.wallet_log.user.national_code" />
                <label-value label="شماره تماس" :value="propsData.wallet_log.user.phone" />
            </bita-formgroup>
        </div>
        <div slot="footer">
            <bita-bootbutton
                    class="mr-2"
                    type="danger"
                    title="بستن"
                    icon="fas fa-times"
                    btn-width="150px"
                    data-dismiss="modal"
            />
        </div>
    </bita-modal>
</template>
<script>
import LabelValue from "./LabelValue";
export default {
    components: {LabelValue },
    props: {
        modalId: {},
        isLoading: {},
        title: {},
        propsData: {},
    },
    methods: {
        onCloseModal() {},
    }
};
</script>